export const RIGHT_MENU_WIDTH_PX = 380; // KEEP THIS in coordination with $md-right-menu-width variable
